"use client";

// src/components/ThemeProvider/ThemeProviderContext.tsx
import { createContext, useContext } from "react";
var ThemeContext = createContext(
  null
);
var ThemeContextProvider = ThemeContext.Provider;
var useThemeContext = () => {
  const context = useContext(ThemeContext);
  return context;
};

export {
  ThemeContextProvider,
  useThemeContext
};
